import Button from 'components/Button'
import Icon from 'components/Icon'
import ModalDialog from 'components/ModalDialog'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Text,
  VStack,
  Button as ChakraButton
} from '@chakra-ui/react'
import {
  DARK_PAGE_BG,
  DARK_TABLE_BORDER,
  DARK_TEXT_PRIMARY,
  DARK_TEXT_MUTED,
  DARK_GREY
} from 'constants/dark-tokens'
import styles from './styles.module.scss'

interface IDeleteDialogProps {
  isOpen: boolean
  message: string
  toggle: () => void
  onDelete: () => void
  onCancel: () => void
  dark?: boolean
}

const DeleteDialog = (props: IDeleteDialogProps) => {
  const { isOpen, message, toggle, onDelete, onCancel, dark = false } = props

  if (dark) {
    return (
      <Modal isCentered isOpen={isOpen} onClose={toggle}>
        <ModalOverlay bg="rgba(0,0,0,0.6)" />
        <ModalContent
          bg={DARK_PAGE_BG}
          border={`1px solid ${DARK_TABLE_BORDER}`}
          color={DARK_TEXT_PRIMARY}
          borderRadius="12px"
        >
          <ModalBody py={6}>
            <VStack spacing={3} align="center">
              <Text
                fontWeight={700}
                fontSize="14px"
                color="#F03D3D"
                m={0}
                textAlign="center"
              >
                WARNING: THIS ACTION CANNOT BE UNDONE
              </Text>
              <Text fontSize="16px" color={DARK_TEXT_MUTED} m={0} textAlign="center">
                {message}
              </Text>
            </VStack>
          </ModalBody>
          <ModalFooter justifyContent="center" gap={4}>
            <ChakraButton
              bg="#E53E3E"
              color="white"
              borderRadius="12px"
              fontWeight={600}
              border="none"
              minW="120px"
              _hover={{ bg: '#C53030' }}
              _focus={{ boxShadow: 'none' }}
              onClick={onDelete}
            >
              Yes, Delete
            </ChakraButton>
            <ChakraButton
              bg="transparent"
              border={`1px solid ${DARK_GREY}`}
              color={DARK_TEXT_MUTED}
              borderRadius="12px"
              fontWeight={600}
              minW="120px"
              _hover={{ bg: 'rgba(255,255,255,0.06)' }}
              _focus={{ boxShadow: 'none' }}
              onClick={onCancel}
            >
              Cancel
            </ChakraButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  return (
    <ModalDialog isOpen={isOpen} toggle={toggle} headless className={styles.deleteDialog}>
      <Icon icon="trash-alt" group="unicon" />
      <p>WARNING: THIS ACTION CANNOT BE UNDONE</p>
      <p>{message}</p>
      <div className={styles.actionBtns}>
        <Button className={styles.deleteButton} onClick={onDelete}>
          Yes, Delete
        </Button>
        <Button outline className={styles.cancelButton} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </ModalDialog>
  )
}

export default DeleteDialog
